module.exports = __webpack_public_path__ + "static/img/tab2zh-Mm9Nn0Oo.51ee3d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/tab2zh-Mm9Nn0Oo.png
// module id = k8vD
// module chunks = 16